var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONFIG } from "../../config/app.config";
import api from "../../utils/api/api.utils";
import { appendFilter } from "../../utils/api.utils";
import { mapObjectWithTimeZonedDatesToUtcIsoString } from "../../utils/date.utils";
export var getSubscription = function (subscriptionId) {
    return api.get("/subscriptions/".concat(subscriptionId));
};
export var createSubscription = function (data) {
    return api.post("/subscriptions", {
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data),
    });
};
export var updateSubscription = function (subscriptionId, data) {
    return api.patch("/subscriptions/".concat(subscriptionId), {
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data),
    });
};
export var deleteSubscription = function (subscriptionId) {
    return api.delete("/subscriptions/".concat(subscriptionId));
};
export var getSubscriptions = function (skip, filterData, limit) {
    if (filterData === void 0) { filterData = {}; }
    if (limit === void 0) { limit = CONFIG.DEFAULT_FETCH_LIMIT; }
    var filter = __assign({ order: "createdAt DESC", limit: limit, skip: skip }, filterData);
    return api.get(appendFilter("/subscriptions", filter));
};
export var submitSubscription = function (invoiceId) {
    return api.post("/subscriptions/".concat(invoiceId, "/submit"));
};
export var markSubscriptionAsPaid = function (invoiceId) {
    return api.post("/subscriptions/".concat(invoiceId, "/mark-paid"));
};
